import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import theme from 'fe-appdir-lib-theme';
import { truncate } from 'fe-appdir-lib-utils';
import { Link } from 'fe-appdir-comp-link';

const PROP_TYPES = {
  name: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  imgSrc: PropTypes.string,
  url: PropTypes.string,
  slug: PropTypes.string,
  onClick: PropTypes.func,
  gaResultClickCallback: PropTypes.func,
};

const DEFAULT_PROPS = {
  imgSrc: '',
};

const ImageCard = styled.div`
  margin-right: ${theme.spacingMd};
  padding: ${theme.spacingSm};
  height: 48px;
  width: 48px;
  border-radius: 4px;
  box-sizing: border-box;
  flex-shrink: 0;
  box-shadow: ${theme.boxShadowBase};
  transition: box-shadow 0.2s;
`;

const TextWrapper = styled.div`
  font-family: ${theme.fontFamilyPrimary};
  color: ${theme.colorBase};
`;

const ResultView = styled(Link)`
  padding: ${theme.spacingSm} ${theme.spacingXl};
  display: flex;
  text-decoration: none;

  @media (max-width: ${theme.breakpointSm}) {
    padding: ${theme.spacingMd} ${theme.spacingXxl};
    display: flex;
    align-items: center;
  }

  &:hover ${ImageCard} {
    box-shadow: ${theme.boxShadowCard};
  }

  &:hover ${TextWrapper} {
    color: ${theme.colorBrandPrimary};
  }
`;

const Image = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

const Name = styled.p`
  margin: 2px 0;
  font-size: ${theme.fontSizeBase};
  font-weight: ${theme.fontWeightSemibold};
`;

const Body = styled.p`
  margin: 0;
  font-size: ${theme.fontSizeSm};

  @media (max-width: ${theme.breakpointSm}) {
    display: none;
  }
`;

const Result = ({
  name,
  body,
  imgSrc,
  url,
  slug,
  onClick,
  gaResultClickCallback,
}) => {
  // Send analytics hit if needed
  let myOnClick = onClick;
  if (gaResultClickCallback)
    myOnClick = () => {
      gaResultClickCallback(slug);
      onClick();
    };

  return (
    <ResultView to={url} onClick={myOnClick}>
      {!!imgSrc && (
        <ImageCard>
          <Image src={imgSrc} alt={name} />
        </ImageCard>
      )}
      <TextWrapper>
        <Name>{name}</Name>
        <Body>{truncate(body, 200)}</Body>
      </TextWrapper>
    </ResultView>
  );
};

Result.propTypes = PROP_TYPES;
Result.defaultProps = DEFAULT_PROPS;
Result.displayName = 'Result';

export default Result;
